module.exports = __webpack_public_path__ + "media/images/japan/useful_3-617f21e758f9eecd70fc4cf593c53e1d.jpg";